<template>
  <v-navigation-drawer :value="isDrawerOpen" app floating width="260" class="app-navigation-menu" :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)">
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pt-2">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            SIDIKBANG TEGAL
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>
    <div class="ps-6" style="border-bottom: 1px solid grey; padding-bottom: 5px;">{{ user.nama }}</div>

    <!-- Navigation Items -->
    <v-list v-if="user.role == 'ADMIN'" expand shaped class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Pelatihan" :to="{ name: 'AdminPelatihan' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-link title="Pengguna" :to="{ name: 'User' }" :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-group title="Master" :icon="icons.mdiFileOutline">
        <nav-menu-link title="Pertanyaan Evaluasi" :to="{ name: 'AdminMasterPertanyaan' }"></nav-menu-link>
      </nav-menu-group>
    </v-list>
    <v-list v-if="user.role == 'PESERTA'" expand shaped class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Daftar Pelatihan" :to="{ name: 'PesertaPelatihan' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-link title="Pelatihan Anda" :to="{ name: 'PesertaStatusPelatihan' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
    </v-list>
    <v-list v-if="user.role == 'PEMATERI'" expand shaped class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Pelatihan Anda" :to="{ name: 'PemateriStatusPelatihan' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
    </v-list>
    <nav-menu-link title="Layanan Pengaduan" :to="{ name: 'LayananPengaduan' }" :icon="icons.mdiCellphoneMessage"></nav-menu-link>
  </v-navigation-drawer>
</template>

<script>
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiCellphoneMessage
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiCellphoneMessage
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  background: white !important;
}

.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item,
.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item::before,
.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item>.v-ripple__container {
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
</style>
